import { Injectable } from '@angular/core';
import { Chart, Tooltip} from 'chart.js';
import { AppTranslateService } from 'src/app/service/core/app-translate.service';
import { log } from 'console';
import { BaseComponent } from '../shared/components/base.component';
@Injectable({
  providedIn: 'root'
})
export class ChartService {

  constructor(private appTranslateService: AppTranslateService,) { }

  // renderChart(_chart,_doughnutCanvas,_doughnutChartLabel,_doughnutChartData,_doughnutColor) {
  //   //console.log("render");
  //     if (_chart) {
  //       _chart.destroy(); // Clean up previous chart
  //       //this.chartCategory.destroy();
  //     }
  //     _chart = new Chart(_doughnutCanvas.nativeElement, {
  //       type: 'doughnut',
  //       data: {
  //         labels:_doughnutChartLabel,
  //         datasets: [{
  //           data: _doughnutChartData,
  //           backgroundColor: _doughnutColor,
  //           hoverBackgroundColor: _doughnutColor.map(c => c + 'AA')
  //         }
          
  //       ]
  //       },
  //       options: {
  //         responsive: true,
  //         plugins: {
  //           legend: {
  //             position: 'right'
  //           }
  //         }
  //       }
  //     });
  // } 


  
renderChart(
  _chart: Chart | undefined,
 // _doughnutCanvas: ElementRef<HTMLCanvasElement>,
  _doughnutCanvas,
  _doughnutChartLabel: string[],
  _doughnutChartData: number[],
  _doughnutColor: string[],
  _isCurrency:boolean=false
) {
  const CurrentLang=this.appTranslateService.getCurrentLang();
  if (_chart) {
    _chart.destroy();
  }

  _chart = new Chart(_doughnutCanvas.nativeElement, {
    type: 'doughnut',
    data: {
      labels: _doughnutChartLabel,
      datasets: [{
        data: _doughnutChartData,
        backgroundColor: _doughnutColor,
        hoverBackgroundColor: _doughnutColor.map(c => c + 'AA')
      }]
    },
   
    options: {
      responsive: true,
      legend: {
        position: 'right'
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            const label = data.labels[tooltipItem.index] || '';
            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if(_isCurrency)
            {
              const usFormatter = new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              if(CurrentLang==='ar')
              {
                return `${label}: د.إ. ${usFormatter.format(value)}`;               
              }
              else{
              return `${label}: AED ${usFormatter.format(value)}`;
              }
            }
            return `${label}: ${value}`;
          }
        }
      }
    }

  });
}


renderDougNutMultiLayerChart(
  _doughnutCanvas,
  _doughnutChartLabel: string[],       // e.g., employee names or ['Q1','Q2','Q3','Q4']
  _doughnutChartData: number[][],      // one array per dataset (ring), same length as labels
  _doughnutColor: string[][],          // one array of colors per dataset, same length as labels
  _doughnutLabelArray: string[],       // dataset labels (ring labels), e.g., dates/years
  _isCurrency: boolean = false
) {

   const CurrentLang=this.appTranslateService.getCurrentLang();
//  console.log("CurrentLang",CurrentLang);
  // Build datasets for multi-layer doughnut (one dataset per "ring")
  const datasets = _doughnutChartData.map((data, index) => ({
    label: _doughnutLabelArray[index],                 // legend label for this ring
    data,                                              // values for segments
    backgroundColor: _doughnutColor[index],            // color per segment
    hoverBackgroundColor: _doughnutColor[index].map(c => c + 'AA')
  }));

  // IMPORTANT: for v2 we use legend/tooltips directly (NOT plugins.*)
  const chart = new Chart(_doughnutCanvas.nativeElement, {
    type: 'doughnut',
    data: {
      labels: _doughnutChartLabel,     // shared segment labels across datasets
      datasets
    },
    options: {
      responsive: true,
      legend: {
        position: 'right'
      },
      tooltips: {
        callbacks: {
          // v2 signature: (tooltipItem, data)
          label: function (tooltipItem, data) {
            const chartLabel =
              data.labels && data.labels[tooltipItem.index]
                ? data.labels[tooltipItem.index]
                : '';

            const chaLayerLabel =
              data.datasets &&
              data.datasets[tooltipItem.datasetIndex] &&
              data.datasets[tooltipItem.datasetIndex].label
                ? data.datasets[tooltipItem.datasetIndex].label
                : '';

            const value: number =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

            // Format and append AED as requested
            if (_isCurrency) {
              const usFormatter = new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              //const aedText = this.translate.instant('aed'); // e.g., "AED"
              if(CurrentLang==='ar')
              {
                return chaLayerLabel
                  ? `${chaLayerLabel} - ${chartLabel} : د.إ. ${usFormatter.format(value)}`
                  : `${chartLabel}: د.إ. ${usFormatter.format(value)}`;
              }
              else
              {
                 return chaLayerLabel
                ? `${chaLayerLabel} - ${chartLabel}: AED ${usFormatter.format(value)}`
                : `${chartLabel}: AED ${usFormatter.format(value)} `;
              }
            }

            return chaLayerLabel
              ? `${chaLayerLabel} - ${chartLabel}: ${value}`
              : `${chartLabel}: ${value}`;
          }
        }
      }
    }
  });

  function isArabic(str: string): boolean {
  return /\p{Script=Arabic}/u.test(str);
}
  return chart;
}


    generateColors(count: number): string[] {
       const palette =  ['#0d3b1aff',  '#5ab892ff', '#b9deb4ff', '#747673ff', '#bfbdbbff','#6B8E23ff', '#27F557ff','#482bf0ff', '#ec6104ff', 'rgba(186, 102, 189, 1)', '#94510eff'
        , '#ac667dff','#89a005b7','#E7FEEC','#69706bff','#64d9eeff','#7179dfff','#c6f786ff','#27F5BE'
        ,'#079C2A','#05701E','#6C9375'];

    
      return palette.slice(0, count);
    

    }
    
// generateHoverColor(hex: string, percent: number): string {
//   // Convert hex to RGB and darken/lighten
//   let num = parseInt(hex.replace('#',''),16),
//       r = (num >> 16) + percent,
//       g = ((num >> 8) & 0x00FF) + percent,
//       b = (num & 0x0000FF) + percent;
//   return `rgb(${Math.min(255,r)},${Math.min(255,g)},${Math.min(255,b)})`;
// }


    getColors(count)
    {
        const palette =  ['rgb(168, 152, 142)', 'rgb(233, 236, 45)','#482bf0ff', 'rgb(241, 207, 184)', '#b332a8ff', '#94510eff'
        , '#ac667dff','#89a005b7','#E7FEEC','#69706bff','#64d9eeff','#7179dfff','#c6f786ff','#27F5BE'
        ,'#079C2A','#05701E','#6C9375'];

     return palette[count];
    }


    ////////////////////////////////
    //Please use this function for chart color
    //////////////////////////////////

    getChartColors(count)
    {
      const hue = ((count * (360 / 20)) + 32) % 360;
      // const hue = (count * (360 / 20)) % 360;
       const base = `hsl(${hue}, 65%, 55%)`;
       const hover = `hsl(${hue}, 65%, 40%)`;
       return { base, hover };
    }

    
    
  
}
